<template>
  <div v-if="data">
    <div class="container" ref="container">
      <div class="row">
        <div class="col-lg">
          <button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">&#8592;</button>
        </div>
        <div class="col-lg">
          <progress-bar :options="options" :value="60" />
        </div>
        <div class="col-lg">
          <!-- <button type="button" class="btn btn-link btn-r"
           :disabled="!this.screening.value" @click="$router.push('/scr-c')">&#8594;</button> -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <img class="img" :src="data.syringesScr.image.url" />
          <div class="clearfix--min"></div>
          <h6 v-html="data.syringesScr.header"></h6>
          <div class="clearfix"></div>
          <!-- No mobile -->
          <div v-if="!isPhone" class="btn-toolbar text-center"
            role="toolbar" aria-label="Toolbar with button groups">
            <div class="btn-group-toggle" role="group"
              v-for="opt in data.syringesScr.options" :value="opt.value" v-bind:key="opt.label">
              <label class="btn btn-primary btn-lg radio-btn"
              @click="toggleActive($event)" :class="parseInt(opt.value) === 0 ? 'no': ''">
                <input type="radio"
                v-model="screening"
                :value="{ q: data.syringesScr.header, value: opt.value }"
                autocomplete="off">{{ opt.label }}
              </label>
            </div>
          </div>
          <!-- Mobile -->
          <div v-if="isPhone">
            <div class="btn-group-toggle" v-for="opt in data.syringesScr.options" :value="opt.value" v-bind:key="opt.label">
              <label class="btn btn-primary btn-lg radio-btn"
              @click="toggleActive($event)" :class="parseInt(opt.value) === 0 ? 'no': ''">
                <input type="radio"
                v-model="screening"
                :value="{ q: data.syringesScr.header, value: opt.value }"
                autocomplete="off">{{ opt.label }}
              </label>
              <div class="clearfix"></div>
            </div>
          </div>
          <small class="disclaimer" v-html="data.syringesScr.disclaimer"></small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { isMobile } from 'mobile-device-detect'
import $ from 'jquery'

export default {
  name: 'scrneedle',
  components: {},
  data () {
    return {
      data: null,
      language: sessionStorage.getItem('language'),
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      isPhone: isMobile,
      screening: {
        q: '',
        value: ''
      },
      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          dynamicPosition: false,
          hideText: true
        },
        progress: {
          color: '#82ab5b',
          backgroundColor: '#B8C9B8',
          inverted: false
        },
        layout: {
          height: 15,
          width: !isMobile ? $(window).width() - 600 : $(window).width() - 100,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      }
    }
  },
  methods: {
    toggleActive (event) {
      $('.radio-btn').not(event.target).removeClass('active')
      $(event.target).parents('label').toggleClass('active')
    }
  },
  watch: {
    screening (scr) {
      if (scr && scr.value) {
        // eslint-disable-next-line
        const answer = this.screening.value === '1' ? true : false
        sessionStorage.setItem('sharingSyringe', answer)
        this.$router.push('/scr-r')
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          syringesScr(locale: ` + sessionStorage.getItem('language') + `) {
            header
            options {
              label
              value
            }
            image {
              url
            }
            disclaimer
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            nextBtn
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
button:disabled {
  opacity: 0.3;
}
.img {
  border-radius: 10px;
  margin: 20px;
  width: 10vw;
  margin-left: auto;
  margin-right: auto;
}
.alert-error {
  display: none;
}
.no {
  background: #06755F !important;
  color: #8FD14F !important;
}
.no:active {
  background: #035a49 !important;
  color: #9fdd60 !important;
}
.radio-btn {
  margin-bottom: .8em;
  margin-right: 1.4em;
  border-color: #069ccc;
  background: #fff;
  color: #000;
  font-size: 1.1em;
  border-radius: .3rem !important;
  width: 13vw;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .radio-btn {
    margin-bottom: .05em;
    padding: .3em;
    width: 100%;
  }
  .container {
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrNeedle.vue